import React from 'react';
import LongText from '../../../Elements/LongText';
import TpJobItem from '../TpJob/TpJobItem';
import FieldTypesEnum from '../../../Enums/FieldTypesEnum';
import stringHelper from '../../../Helpers/stringHelper';

export default class ExcludedTpJobTpEvaluatorItem extends TpJobItem {
  static clickOnGlobalSelect(item, selected) {
    // Placeholder, don't remove it!
  }

  static clickOnSelect(item, selected) {
    // Placeholder, don't remove it!
  }

  static selectedStatus() {
    return false;
  }

  static getSelectedCellContent(item) {
    return (
      <input
        type='checkbox'
        checked={item.Selected}
        onChange={(e) => {
          ExcludedTpJobTpEvaluatorItem.clickOnSelect(item, e.target.checked);
        }}
      />
    );
  }

  static getSelectedCellHeader(item) {
    return (
      <input
        type='checkbox'
        checked={ExcludedTpJobTpEvaluatorItem.selectedStatus()}
        onChange={(e) => {
          ExcludedTpJobTpEvaluatorItem.clickOnGlobalSelect(item, e.target.checked);
        }}
      />
    );
  }

  static FieldsToShowInDataTable() {
    return [
      {
        label: ExcludedTpJobTpEvaluatorItem.getSelectedCellHeader,
        orderById: '',
        data: ExcludedTpJobTpEvaluatorItem.getSelectedCellContent,
        type: FieldTypesEnum.PureDataField,
        minWidth: 10,
      },
      {
        label: 'Third-Party Job ID',
        orderById: 'ThirdPartyJobId',
        data: ExcludedTpJobTpEvaluatorItem.idFunction,
        minWidth: '80px',
      },
      { label: 'Client', orderById: 'CaspianClientDetails', data: 'CaspianClientDetails', minWidth: 50 },
      {
        label: 'Project',
        orderById: 'ProjectNameAndId',
        data: (item) => (
          <LongText
            text={item.ProjectNameAndId}
            maxLength={12}
          />
        ),
        minWidth: 100,
      },
      { label: 'Location', orderById: 'ThirdPartyLocationName', data: 'ThirdPartyLocationName', minWidth: 50 },
      {
        label: 'Eval Addit. Fee',
        orderById: 'EvaluatorFeeAdjustment',
        data: (item) =>
          stringHelper.getValueWithSymbol(
            '',
            item.EvaluatorCurrencySymbol,
            TpJobItem.getFeeAmount(item.EvaluatorFeeAdjustment)
          ),
        minWidth: 50,
      },
      {
        label: 'Eval Reimb.',
        orderById: 'EvaluatorReimbursement',
        data: (item) =>
          stringHelper.getValueWithSymbol(
            '',
            item.ReimbursementCurrencySymbol,
            TpJobItem.getFeeAmount(item.EvaluatorReimbursement)
          ),
        minWidth: 50,
      },
      {
        label: 'Eval Travel',
        orderById: 'EvaluatorTravel',
        data: (item) =>
          stringHelper.getValueWithSymbol(
            '',
            item.ReimbursementCurrencySymbol,
            TpJobItem.getFeeAmount(item.EvaluatorTravel)
          ),
        minWidth: 50,
      },
      {
        label: 'Eval Gaming',
        orderById: 'EvaluatorGaming',
        data: (item) =>
          stringHelper.getValueWithSymbol(
            '',
            item.ReimbursementCurrencySymbol,
            TpJobItem.getFeeAmount(item.EvaluatorGaming)
          ),
        minWidth: 50,
      },
      {
        label: 'Eval Misc',
        orderById: 'EvaluatorMisc',
        data: (item) =>
          stringHelper.getValueWithSymbol(
            '',
            item.ReimbursementCurrencySymbol,
            TpJobItem.getFeeAmount(item.EvaluatorMisc)
          ),
        minWidth: 50,
      },
      { label: 'FW Office', orderById: 'FieldworkOfficeName', data: 'FieldworkOfficeName' },
      { label: 'FW Fee', orderById: 'FieldworkFeeWithSymbol', data: 'FieldworkFeeWithSymbol', minWidth: 50 },
      { label: 'Evaluator', orderById: 'TpEvaluatorFullName', data: 'TpEvaluatorFullName', minWidth: 50 },
      { label: 'Status', orderById: 'ThirdPartyJobStatus', data: 'ThirdPartyJobStatus', minWidth: 60 },
      {
        label: 'Completed On',
        orderById: 'JobDate',
        data: 'JobDate',
      },
      { label: 'Country', orderById: 'ThirdPartyLocationCountry', data: 'ThirdPartyLocationCountry' },
      {
        label: 'Uninvoiceable',
        orderById: 'IsUninvoiceable',
        data: (item) => ExcludedTpJobTpEvaluatorItem.badgeFunction(item.IsUninvoiceable === true),
        minWidth: 20,
      },
    ];
  }
}
